import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 成本
 */
const cost = {

  /**
   * 添加能源能源计价方式
   */
  addCompanyPricingModeOfEnergyCost (companyId, energyType, model, pricingModelParams, startDate, endDate) {
    pricingModelParams = utils.arrayToJsonString(pricingModelParams)
    return axios.post(base.cost.addCompanyPricingModeOfEnergyCost, utils.postParamsArrayToJsonString({ companyId, energyType, model, pricingModelParams, startDate, endDate }))
  },
  /**
   * 查询能源计价方式
   */
  getCompanyPricingModeOfEnergyCost (companyId, energyType) {
    return axios.post(base.cost.getCompanyPricingModeOfEnergyCost, utils.postParamsArrayToJsonString({ companyId, energyType }))
  },
  /**
   * 修改能源计价方式
   */
  modifyCompanyPricingModeOfEnergyCost (pricingRegulationId, startDate, endDate) {
    return axios.post(base.cost.modifyCompanyPricingModeOfEnergyCost, utils.postParamsArrayToJsonString({ pricingRegulationId, startDate, endDate }))
  },
  /**
   * 删除能源计价方式
   */
  deleteCompanyPricingModeOfEnergyCost (pricingRegulationId) {
    return axios.post(base.cost.deleteCompanyPricingModeOfEnergyCost, utils.postParamsArrayToJsonString({ pricingRegulationId }))
  },
  /**
   * 修改计价模型参数
   */
  modifyPricingModelParams (id, params) {
    return axios.post(base.cost.modifyPricingModelParams, utils.postParamsArrayToJsonString({ id, params }))
  },
  /**
   * 查询成本
   */
  getSpentMoney (measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoney, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyHour (measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyHour, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyMonth (measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyMonth, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyYear (measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyYear, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyHour2 (measures, startTime, endTime, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyHour2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyMonth2 (measures, startTime, endTime, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyMonth2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyYear2 (measures, startTime, endTime, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyYear2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyHour3 (measureId, startTime, span, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyHour3, utils.postParamsArrayToJsonString({ measureId, startTime, span, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyMonth3 (measureId, startTime, span, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyMonth3, utils.postParamsArrayToJsonString({ measureId, startTime, span, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyYear3 (measureId, startTime, span, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyYear3, utils.postParamsArrayToJsonString({ measureId, startTime, span, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyDay (measureId, startTime, endTime, pointCode, pointNumber, energyType) {
    return axios.post(base.cost.getSpentMoneyDay, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, energyType }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyWeek (measureId, startTime, endTime, pointCode, pointNumber, energyType) {
    return axios.post(base.cost.getSpentMoneyWeek, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, energyType }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyDay2 (measureId, startTime, span, pointCode, pointNumber, energyType) {
    return axios.post(base.cost.getSpentMoneyDay2, utils.postParamsArrayToJsonString({ measureId, startTime, span, pointCode, pointNumber, energyType }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyWeek2 (measureId, startTime, span, segments, pointCode, pointNumber, energyType) {
    return axios.post(base.cost.getSpentMoneyWeek2, utils.postParamsArrayToJsonString({ measureId, startTime, span, pointCode, pointNumber, energyType }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyDay3 (measures, startTime, endTime, segments, energyType) {
    return axios.post(base.cost.getSpentMoneyDay3, utils.postParamsArrayToJsonString({ measures, startTime, endTime, energyType }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyWeek3 (measures, startTime, endTime, segments, energyType) {
    return axios.post(base.cost.getSpentMoneyWeek3, utils.postParamsArrayToJsonString({ measures, startTime, endTime, energyType }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyDay4 (measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyDay4, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyWeek4 (measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId) {
    return axios.post(base.cost.getSpentMoneyWeek4, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, energyType, segmentId }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyDay5 (measures, startTime, endTime, segmentId, energyType) {
    return axios.post(base.cost.getSpentMoneyDay5, utils.postParamsArrayToJsonString({ measures, startTime, endTime, segmentId, energyType }))
  },
  /**
   * 查询成本
   */
  getSpentMoneyWeek5 (measures, startTime, endTime, segmentId, energyType) {
    return axios.post(base.cost.getSpentMoneyWeek5, utils.postParamsArrayToJsonString({ measures, startTime, endTime, segmentId, energyType }))
  },
}

export default cost
